import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e5e5e5",
          padding: "1rem 2rem",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <nav
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <a
            href="/"
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              letterSpacing: "-0.5px",
              textDecoration: "none",
            }}
          >
            Collavo
          </a>
          <a
            href="/"
            style={{
              backgroundColor: "transparent",
              color: "#1a1a1a",
              padding: "10px 24px",
              fontSize: "15px",
              fontWeight: "500",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            Back to Home
          </a>
        </nav>
      </header>

      {/* Content */}
      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "4rem 2rem",
        }}
      >
        <h1
          style={{
            fontSize: "48px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "1rem",
            letterSpacing: "-1px",
          }}
        >
          Privacy Policy
        </h1>

        <p
          style={{
            fontSize: "15px",
            color: "#737373",
            marginBottom: "3rem",
          }}
        >
          Last updated: February 2026
        </p>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Introduction
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Collavo ("we," "us," or "our") is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you use our platform.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            By using Collavo, you agree to the collection and use of information
            in accordance with this policy.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Information We Collect
          </h2>

          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "0.75rem",
              marginTop: "1.5rem",
            }}
          >
            Information You Provide
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            When you create an account and profile, we collect:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>Name and email address</li>
            <li>Church affiliation and location</li>
            <li>Service type (Speaker, Musician, or Other)</li>
            <li>Professional bio and expertise areas</li>
            <li>Service description and typical session length</li>
            <li>Travel preferences and postal address</li>
            <li>Availability and advance notice requirements</li>
            <li>Pricing model and rate information</li>
          </ul>

          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "0.75rem",
              marginTop: "1.5rem",
            }}
          >
            Automatically Collected Information
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            When you use our platform, we may automatically collect:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
            }}
          >
            <li>Device information (browser type, operating system)</li>
            <li>IP address and general location data</li>
            <li>Usage data (pages viewed, features used)</li>
            <li>Authentication tokens and session data</li>
          </ul>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            How We Use Your Information
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            We use the information we collect to:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
            }}
          >
            <li>Create and manage your account</li>
            <li>Display your profile to churches searching for services</li>
            <li>Enable communication between service providers and churches</li>
            <li>Improve and optimize our platform</li>
            <li>
              Send you important updates about your account or our services
            </li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Detect and prevent fraud or abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Information Sharing and Disclosure
          </h2>

          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "0.75rem",
              marginTop: "1.5rem",
            }}
          >
            Public Profile Information
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            When you create a service provider profile, certain information is
            made publicly visible to help churches find and evaluate potential
            service providers. This includes your name, church affiliation,
            service type, bio, expertise areas, service description, general
            location, availability preferences, and pricing model.
          </p>

          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "0.75rem",
              marginTop: "1.5rem",
            }}
          >
            Information We Do Not Share
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            We do not sell, rent, or trade your personal information to third
            parties. We do not share your email address, specific postal
            address, or any private account information publicly.
          </p>

          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "0.75rem",
              marginTop: "1.5rem",
            }}
          >
            Service Providers
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We use Supabase for authentication and database services. These
            service providers have access to your information only to perform
            tasks on our behalf and are obligated not to disclose or use it for
            other purposes.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Data Security
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            We implement appropriate technical and organizational security
            measures to protect your personal information. However, no method of
            transmission over the internet or electronic storage is 100% secure,
            and we cannot guarantee absolute security.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We use industry-standard encryption for data transmission, secure
            authentication methods, and regular security assessments to protect
            your information.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Your Rights and Choices
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            Under UK GDPR, you have the following rights:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>
              <strong>Access:</strong> Request a copy of the personal data we
              hold about you
            </li>
            <li>
              <strong>Correction:</strong> Request correction of inaccurate or
              incomplete data
            </li>
            <li>
              <strong>Deletion:</strong> Request deletion of your personal data
            </li>
            <li>
              <strong>Portability:</strong> Request transfer of your data to
              another service
            </li>
            <li>
              <strong>Objection:</strong> Object to processing of your personal
              data
            </li>
            <li>
              <strong>Restriction:</strong> Request restriction of processing
            </li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            To exercise these rights, please contact us using the information
            provided at the end of this policy.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Profile Management
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            You can manage your profile information at any time by:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
            }}
          >
            <li>Editing your profile through your dashboard</li>
            <li>
              Deactivating your profile (makes it invisible to churches but
              preserves your data)
            </li>
            <li>
              Deleting your account entirely (permanently removes all your data)
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Data Retention
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We retain your personal information for as long as your account is
            active or as needed to provide you services. If you delete your
            account, we will delete or anonymize your personal information
            within 30 days, except where we are required to retain it for legal,
            accounting, or security purposes.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Cookies and Tracking
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            We use essential cookies to maintain your session and provide basic
            functionality. We do not use third-party tracking or advertising
            cookies.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You can control cookies through your browser settings, but disabling
            essential cookies may affect your ability to use certain features of
            the platform.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Children's Privacy
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            Our service is not intended for children under 18. We do not
            knowingly collect personal information from children. If you believe
            we have collected information from a child, please contact us
            immediately.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Changes to This Privacy Policy
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last updated" date. Significant changes will be
            communicated via email to registered users.
          </p>
        </section>

        <section
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Get In Touch
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1.5rem",
            }}
          >
            Have questions, feedback, or just want to say hello?
          </p>
          <a
            href="/contact"
            style={{
              display: "inline-block",
              backgroundColor: "#000",
              color: "#fff",
              padding: "12px 32px",
              fontSize: "15px",
              fontWeight: "500",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
            }}
          >
            Contact Us
          </a>
        </section>

        {/* <section
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Contact Us
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            If you have questions about this Privacy Policy or wish to exercise
            your data rights, please contact us at:
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#1a1a1a",
              fontWeight: "500",
            }}
          >
            Email: privacy@collavo.co.uk
          </p>
        </section> */}
      </main>

      {/* Footer */}
      <footer
        style={{
          borderTop: "1px solid #e5e5e5",
          backgroundColor: "#fff",
          padding: "2rem",
          marginTop: "4rem",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#737373",
              marginBottom: "1rem",
            }}
          >
            <a
              href="/about"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              About
            </a>
            <a
              href="/terms"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              Terms of Service
            </a>
            <a
              href="/contact"
              style={{ color: "#737373", textDecoration: "none" }}
            >
              Contact
            </a>
          </p>
          <p style={{ fontSize: "14px", color: "#737373" }}>
            © 2025 Collavo. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
